import { render, staticRenderFns } from "./StaffPlanEditComplete.vue?vue&type=template&id=21480812"
import script from "./StaffPlanEditComplete.vue?vue&type=script&lang=js"
export * from "./StaffPlanEditComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports